import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/shared/components/ui/dialog'

import { MarketingForm } from './MarketingForm'

export function AddMarketingDialog({ open, onOpenChange, marketing }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[calc(100vw-1.5rem)] max-w-2xl max-h-[90vh] overflow-y-auto rounded-2xl sm:rounded-3xl p-4 sm:p-6 shadow-2xl">
        <DialogHeader>
          <DialogTitle>
            {marketing ? 'Edit Marketing Person' : 'Add Marketing Person'}
          </DialogTitle>
        </DialogHeader>

        <MarketingForm
          key={marketing?._id ?? 'new'}
          marketing={marketing}
          onCancel={() => onOpenChange(false)}
          onSuccess={() => onOpenChange(false)}
        />
      </DialogContent>
    </Dialog>
  )
}
